






















































































































import { Component, Prop, Vue } from 'vue-property-decorator';
import { Getter, Action } from 'vuex-class';
import ActivityLabel from '@/components/common/edit/ActivityLabel.vue';
import getUrlParam from '@/common/utils/getUrlParam';
import getActivityType from '@/common/utils/getActivityType';
import DashLine from '@/components/common/edit/DashLine.vue';
import { majorNoticeText } from '@/common/constants/index';

@Component({
  components: {
    'activity-label': ActivityLabel,
    'dash-line': DashLine
  }
})
export default class SignupItem extends Vue {
  @Prop() noSomeItem!: boolean;
  @Getter('signupItemConfig') signupItemConfig!: any;
  @Getter('xcxFlag') xcxFlag!: boolean;
  @Getter('xmMajordomo') xmMajordomo!: boolean;
  @Getter('xcxType') xcxType!: string;

  @Action('changeSignupItemConfig') changeSignupItemConfig!: Function;

  getActivityType: Function = getActivityType;
  isReEdit: boolean = getUrlParam('type') === 'reEdit';
  countTrue: number = 0;
  openNumber: number = 0;
  openCustomModal: boolean = false;
  customName: string = '';
  customType: string = 'text';
  editIndex: number = -1;
  selectList: any = [];
  customizeList: any = [];

  mounted() {
    setTimeout(() => {
      this.customizeList = this.signupItemConfig.customizeList || [];
      let countTrue: number = 0;
      let openNumber: number = 0;
      for (let key in this.signupItemConfig) {
        if (key == 'customizeList') continue;
        this.signupItemConfig[key] && countTrue++;
      }
      this.customizeList.map((item: any) => {
        item.isOpen && openNumber++;
      });
      this.countTrue = countTrue;
      this.openNumber = openNumber;
    }, 2000);
  }

  // 图片资源
  checkboxFixed: string = 'https://xiaomai-image.oss-cn-hangzhou.aliyuncs.com/1571311580233.png?x-oss-process=image/resize,w_300,limit_0';
  checkboxClean: string = 'https://xiaomai-image.oss-cn-hangzhou.aliyuncs.com/1571311568546.png?x-oss-process=image/resize,w_300,limit_0';
  checkboxDirty: string = 'https://xiaomai-image.oss-cn-hangzhou.aliyuncs.com/1571311462221.png?x-oss-process=image/resize,w_300,limit_0';
  checkboxSelected: string = 'https://image.xiaomaiketang.com/xm/D2K57F26W8.png';

  changeName(e: any) {
    const value = (e.target.value || '').trim();
    this.customName = value;
  }

  selectType(value: string) {
    this.customType = value;
    if (value == 'select' && this.selectList.length == 0) {
      this.selectList = [''];
    } else if (value == 'text') {
      this.selectList = [];
    }
  }

  addSelect() {
    this.selectList.push('');
  }

  changeSelectList(e: any, index: number) {
    this.selectList[index] = (e.target.value || '').trim();
  }

  deleteSelect(index: number) {
    this.selectList.splice(index, 1);
  }

  closeModal() {
    this.openCustomModal = false;
    this.resetModal();
  }

  deleteModal() {
    Vue.$confirm({
      text: '确定删除吗',
      ok: () => {
        this.openCustomModal = false;
        this.customizeList.splice(this.editIndex, 1);
        this.openNumber = this.openNumber - 1;
        this.resetModal();
      }
    });
  }

  handleCustomOpen(index: number) {
    if (this.xcxType === 'mkb') {
      return;
    }
    if (this.xcxFlag && !this.xmMajordomo) {
      Vue.$confirm({
        oneBtn: true,
        title: '提示',
        text: majorNoticeText,
        okText: '确定'
      });
      return;
    }

    if (getUrlParam('type') === 'reEdit') {
      Vue.$toast.error('发布活动后不可修改报名信息选项');
      return;
    }
    const isOpen = this.customizeList[index].isOpen;
    if (!this.noSomeItem) {
      if (isOpen || this.openNumber + this.countTrue <= 7) {
        this.customizeList[index].isOpen = !isOpen;
        if (isOpen) {
          this.openNumber = this.openNumber - 1;
        } else {
          this.openNumber = this.openNumber + 1;
        }
        this.signupItemConfig['customizeList'] = this.customizeList;
        this.changeSignupItemConfig(JSON.stringify(this.signupItemConfig));
      } else {
        Vue.$toast.info('最多可设置10项');
      }
    } else {
      if (isOpen || this.openNumber + this.countTrue <= 2) {
        this.customizeList[index].isOpen = !isOpen;
        if (isOpen) {
          this.openNumber = this.openNumber - 1;
        } else {
          this.openNumber = this.openNumber + 1;
        }
        this.signupItemConfig['customizeList'] = this.customizeList;
        this.changeSignupItemConfig(JSON.stringify(this.signupItemConfig));
      } else {
        Vue.$toast.info('最多可设置5项');
      }
    }
  }

  editCustom(e: any, index: number) {
    if (this.xcxType === 'mkb') {
      return;
    }
    if (this.xcxFlag && !this.xmMajordomo) {
      Vue.$confirm({
        oneBtn: true,
        title: '提示',
        text: majorNoticeText,
        okText: '确定'
      });
      return;
    }

    if (getUrlParam('type') === 'reEdit') {
      Vue.$toast.error('发布活动后不可修改报名信息选项');
      return;
    }
    e.stopPropagation();
    e.preventDefault();
    const data = this.customizeList[index];
    this.editIndex = index;
    this.openCustomModal = true;
    this.customName = data.key;
    this.customType = data.type;
    this.selectList = data.selection || [];
  }

  submit() {
    if (!this.customName) {
      Vue.$toast.info('请输入自定义名称');
    } else if (this.customType == 'select' && this.selectList.length == 0) {
      Vue.$toast.info('至少要添加1个选项');
    } else if (this.customType == 'select' && this.selectList.some((item: any) => item == '')) {
      Vue.$toast.info('请输入选项名称');
    } else {
      Vue.$toast.success('添加成功');
      this.openCustomModal = false;
      const data: any = {
        isOpen: true,
        key: this.customName,
        type: this.customType
      };
      data.type == 'select' && (data.selection = this.selectList);
      if (this.editIndex >= 0) {
        this.customizeList[this.editIndex] = data;
      } else {
        this.customizeList.push(data);
      }
      this.signupItemConfig['customizeList'] = this.customizeList;
      this.changeSignupItemConfig(JSON.stringify(this.signupItemConfig));
      let openNumber: number = 0;
      this.customizeList.map((item: any) => {
        item.isOpen && openNumber++;
      });
      this.openNumber = openNumber;
      this.resetModal();
    }
  }

  resetModal() {
    this.customName = '';
    this.customType = 'text';
    this.editIndex = -1;
    this.selectList = [];
  }

  // 点击更改选项选中状态
  handleClickItem(kname: string): void {
    if (this.xcxType === 'mkb') {
      return;
    }
    if (this.xcxFlag && !this.xmMajordomo) {
      Vue.$confirm({
        oneBtn: true,
        title: '提示',
        text: majorNoticeText,
        okText: '确定'
      });
      return;
    }

    if (getUrlParam('type') === 'reEdit') {
      Vue.$toast.error('发布活动后不可修改报名信息选项');
      return;
    }

    // 包括默认项在内限制10项
    let countTrue: number = 0;
    let openNumber: number = 0;
    for (let key in this.signupItemConfig) {
      if (key == 'customizeList') continue;
      this.signupItemConfig[key] && countTrue++;
    }
    this.customizeList.map((item: any) => {
      item.isOpen && openNumber++;
    });
    this.countTrue = countTrue + (!this.signupItemConfig[kname] ? 1 : -1);
    this.openNumber = openNumber;
    console.log(countTrue, openNumber);
    if (!this.noSomeItem) {
      if (countTrue + openNumber <= 7 || (countTrue + openNumber >= 3 && this.signupItemConfig[kname])) {
        this.signupItemConfig[kname] = !this.signupItemConfig[kname];
        this.changeSignupItemConfig(JSON.stringify(this.signupItemConfig));
      } else {
        Vue.$toast.info('最多可设置10项');
      }
    } else {
      if (countTrue + openNumber <= 2 || (countTrue + openNumber >= 3 && this.signupItemConfig[kname])) {
        this.signupItemConfig[kname] = !this.signupItemConfig[kname];
        this.changeSignupItemConfig(JSON.stringify(this.signupItemConfig));
      } else {
        Vue.$toast.info('最多可设置5项');
      }
    }
  }

  openAddCustom() {
    if (this.xcxType === 'mkb') {
      return;
    }
    if (this.xcxFlag && !this.xmMajordomo) {
      Vue.$confirm({
        oneBtn: true,
        title: '提示',
        text: majorNoticeText,
        okText: '确定'
      });
      return;
    }
    this.openCustomModal = true;
  }
}
